<div mat-dialog-title class="icon-button-density-minus-5">
  <ng-content></ng-content>
  <button mat-icon-button mat-dialog-close tabindex="-1" class="remove-btn">
    <mat-icon>close</mat-icon>
  </button>
</div>
